@if (loading.state().visible) {
  <div
    class="loading-overlay"
    role="status"
    aria-live="polite"
    [attr.aria-label]="loading.state().message"
    aria-busy="true"
  >
    <div class="loading-card mat-elevation-z8">
      <span class="loader"></span>
      <div class="loading-text">{{ loading.state().message }}</div>
    </div>
  </div>
}
